export const __PRODUCTION__ = process.env.NODE_ENV === 'production';
